import { actionTypes} from '../actions/mostWanted'
import createAsyncReducer from './HOCreducer'

export default createAsyncReducer(actionTypes)
